import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './core/estilos/index.css'
import App from './App.tsx'
import { initVersionCheck } from './core/servicos/versionCheck'

// Inicializa verificação de versão e handler de erros de chunk
initVersionCheck();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
